export const teacherList = [
    {
        "name": "李東華老師",
        "quality": "",
        "introduce": "2018年畢業于暨南大學，掌握普通話、粵語、英語等語言。有四年以上的綫上、綫下教學工作經驗，擅長進行中學、小學的理科科目教學，善於發掘學生在數學理科等方面的學習思路。上課課堂可以做到生動有趣，激發缺省的學習激情，培養學生的學習習慣。教學理念：教育是一件需要努力。需要等待的事情，而學習是人一輩子的重要事。",
        'picture': '../assets/Maths/teacher11.png',
        'type': '1'
    },
    {
        "name": "寧鈞龍老師",
        "quality": "",
        "introduce": "畢業於中國海洋大學，從事教育行業十年，擁有多年帶高考提分經驗，善於引起學生興趣，深入淺出，所帶學生考取華南農業大學、廣東工業大學等知名學府，深受家長和學生信賴，纍計多帶中小學生3000+。",
        'picture': '../assets/Maths/teacher22.png',
        'type': '1'
    },
    {
        "name": "李妍鈺老師",
        "quality": "",
        "introduce": "香港城市大學研究生，曾獲得廣州市教學技能比賽二等獎。 因材施教，關註每位學生的差異，通過個性化的教學輔導後進生，平均提分20分。",
        'picture': '../assets/Maths/teacher33.png',
        'type': '1'
    }
]
export const teacherListHk = [
    {
        "name": "閔老師",
        "quality": "教师资质",
        "introduce": "長安大學(雙一流)畢業，三年小學數學教學經驗，帶過學生超300人/善於將數學知識滲透到多領域科學故事和生活中去，拓展孩子知識面，能抓住孩子注意力/善於將數學知識滲透到多領域科學故事和生活中去，拓展孩子知識面，能抓住孩子注意力。",
        'picture': '../assets/Maths/teacher1.png',
        'picture2': '../assets/Maths/yt1.png',
        'type': '2'
    },
    {
        "name": "鄭老師",
        "quality": "教师资质",
        "introduce": "對待學生和藹可親，課程基礎知識講解清晰，選的題目比較典型，側重于數學思維邏輯的培養，而非機械操作，注重培養學生的綜合能力和注重數學思維的講解，困難的問題解體簡單化/ 知識點由淺入深，特別是一些技巧的講解。",
        'picture': '../assets/Maths/teacher2.png',
        'picture2': '../assets/Maths/yt2.png',
        'type': '2'
    },
    {

        "name": "路老師",
        "quality": "教师资质",
        "introduce": "擁有六年以上教學經驗的教育工作者/2017-2021在私立學校擔任初中數學老師一職，2022-2023在一家培訓機構擔任數學老師，主要負責4-8年級教學工作/2017-2021在私立學校擔任初中數學老師一職，2022-2023在一家培訓機構擔任數學老師，主要負責4-8年級教學工作。",
        'picture': '../assets/Maths/teacher3.png',
        'picture2': '../assets/Maths/yt3.png',
        'type': '2'
    },
]
export const course = [
    {
        "name": "一年級",
        "content": "帶領孩子們發現和認識生活中的基本數學問題，通過課堂討論和遊戲活動引領孩子們認識到數學的趣味性和工具性，從而引發孩子們學習數學的興趣和積極性。從基本的數字和空間，時間角度出發，學習掌握基本的數學計算規則和判斷標準，幫助孩子們建立基本的數學素養和數學計算處理數學問題的能力。",
        "photo": "../assets/Maths/comma1.png",
    },
    {
        "name": "二年級",
        "content": "通過鞏固基本計算能力的基礎上，引領孩子們掌握從單位數到多位數的識數能力和多種類型計算能力，從難到易逐漸提高學生們的思維水準，幫助學生掌握更多的數學知識從而可以解決生活和學習中會遇到的數學問題，擴張學生們的思維廣度，拔高學生們的思維水準。",
        "photo": "../assets/Maths/comma2.png",
    },
    {
        "name": "三年級",
        "content": "帶領學生解決初步進階的乘法、除法、加減乘除混合計算問題，將長度單位、重量單位和體積單位生活化、科技化，生動有趣得講好三角形的故事，帶領孩子的數學完美銜接到難度飛升的4年級。",
        "photo": "../assets/Maths/comma3.png",
    },
    {
        "name": "四年級",
        "content": "重訓練、重應用來攻克三位數與兩位數的乘法、除法、加減混合計算及應用題。進一步帶領學生認識分數，解決分數的加減混合運算，同時解決正方形、長方形、圓的周長和面積問題，最後認識數學新朋友小數。",
        "photo": "../assets/Maths/comma4.png",
    },
    {
        "name": "五年級",
        "content": "帶領孩子認識大位數，暫且將整數海洋的學習告一段落，繼而轉向對不規則圖形面積、立體圖形空間的探索及初步接觸抽象代數，鍛煉孩子的抽象思維、提升孩子的空間想象力來解決實際的數學問題，除此之外，加強孩子對進階的分數、小數的四則混合運算能力。",
        "photo": "../assets/Maths/comma5.png",
    },
    {
        "name": "六年級",
        "content": "六年級我們將實現小學數學計算的完整拼圖：從整數到小數的加減乘除運算及四則混合運算。此後我們將運用這些計算方法並結合方程的概念解決實際生活中遇到的各種數學問題。我們將與孩子繼續深挖平面幾何和立體幾何的各種知識，領略代數和幾何結合的魅力。",
        "photo": "../assets/Maths/comma6.png",
    }
];
export const courseHk = [
    {
        "content": "班級組織激發孩子們的學習興趣和動力",
    },
    {
        "content": "獲得學術上的支持，培養團隊合作和社交能力",
    },
    {
        "content": "一起學習，分享經驗，互相幫助，建立自信，共同進步",
    },
    {
        "content": "氛圍活躍，輕鬆愉悅",
    },
    {
        "content": "與同齡人一起學習和交流，拓展視野，提升自我",
    }
]